import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/styles'
import { Page, Header } from 'components'
import { useCasoService } from 'hooks/useCasoService'
import { Results } from './components'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
}))

export const Casos = (props) => {
  const { route } = props
  const casoService = useCasoService()
  const classes = useStyles()

  const casos = useSelector((state) => state.casos.casos)

  useEffect(() => {
    casoService.listarCasos()
  }, [])

  return (
    <Page className={classes.root} title={`${route.secao} - SIGEP`}>
      <Header titulo={`${route.secao} cadastrados`} overline={route.secao} textoBotao="CADASTRAR CASO" linkBotao={`${route.path}/cadastrar`} />
      {casos && <Results className={classes.results} dados={casos} />}
    </Page>
  )
}
